import { Box, Button, IconButton, Typography } from '@mui/material'

import { useStyles } from './styles'
import BaseModal from '../../../../../../../../../../components/modal/baseModal'
import { icons } from '../../../../../../../../../../utils/icons'
import { PropsModalInput } from './types'
import { LoadingButton } from '@mui/lab'

export const InputModal = ({ isLoader, loaderButton, open, children, title, buttonText, cancelText, next, back, sx, disableButton, hideClose, hiddenFooterButton }: PropsModalInput) => {
    const styles = useStyles()

    return (
        <BaseModal open={open} sx={{ ...styles.baseModal, ...(sx ?? {}) } as object}>

            <Box sx={styles.containerSuccess}>

                {!hideClose && <Box sx={styles.closeSuccess}>
                    <IconButton onClick={() => { back() }} >
                        {icons('simple-close')}
                    </IconButton>
                </Box>}

                <Box sx={styles.containerBody}>
                    {title && <Typography sx={styles.title}>{title}</Typography>}
                    {children}
                </Box>

                {!hiddenFooterButton &&
                    <Box sx={styles.buttonsContainer}>
                        <Button className='back' onClick={() => { back() }} >
                            {cancelText}
                        </Button>

                        {isLoader ?
                            <LoadingButton loading={loaderButton} className='next' variant="contained" disabled={disableButton} onClick={() => { next() }}>
                                {buttonText}
                            </LoadingButton>
                            :
                            <Button className='next' variant="contained" disabled={disableButton} onClick={() => { next() }} >
                                {buttonText}
                            </Button>
                        }

                    </Box>
                }

            </Box>
        </BaseModal>
    )
}
